export const APP_TYPE_OPTIONS = [
  {
    value: 1,
    label: 'WiseDental'
  },
  {
    value: 2,
    label: 'APPLink'
  },
  {
    value: 3,
    label: '艾坚助手'
  }
]

/* eslint-disable */
export const appType = {
  [1]: 'WiseDental',
  [2]: 'APPLink',
  [3]: '艾坚助手'
}

export const APP_STATUS_TYPE = [
  {
    value: 1,
    label: '未上架'
  },
  {
    value: 2,
    label: '已上架'
  }
]

/* eslint-disable */
export const appStatus = {
  [1]: '未上架',
  [2]: '已上架'
}

export const appTableDataSchemas = [
  {
    prop: 'name',
    label: '名称',
    minWidth: 80
  },
  // {
  //   prop: 'type',
  //   label: '应用类型',
  //   minWidth: 120
  // },
  {
    prop: 'applyVersion',
    label: '版本',
    minWidth: 120
  },
  {
    prop: 'applyStatus',
    label: '状态',
    minWidth: 120
  },
  {
    prop: 'createTime',
    label: '创建时间',
    minWidth: 120
  },
  {
    prop: 'action',
    label: '操作',
    minWidth: 150,
    btnArr: ['update', 'dup', 'open', 'down', 'delete']
  }
]

export const classlibtTableDataSchemas = [
  {
    prop: 'fileName',
    label: '文件名称',
    minWidth: 80
  },
  // {
  //   prop: 'type',
  //   label: '应用类型',
  //   minWidth: 120
  // },
  {
    prop: 'fileVersion',
    label: '版本号',
    minWidth: 120
  }, {
    prop: 'uploadTime',
    label: '上传时间',
    minWidth: 120
  },
  {
    prop: 'action',
    label: '操作',
    minWidth: 150,
    btnArr: ['replace', 'delete']
  }
]

export const rules = {
  value: [
    {
      required: true,
      message: '审批人不能为空'
    }
  ],
  level: [
    {
      required: true,
      message: '审批顺序节点不能为空'
    }
  ]
}


// 基础设置 form
export const formSchemas = [
  {
    field: 'code',
    defaultValue: '',
    component: 'Select',
    label: '应用',
    rules: [
      {
        required: true,
        message: '应用不能为空'
      }
    ]
  },
  {
    field: 'applyVersion',
    defaultValue: '',
    component: 'Input',
    label: '应用版本',
    placeholder: '请填写应用版本',
    rules: [
      {
        required: true,
        message: '版本不能为空'
      }
    ]
  },
  {
    field: 'applyRunVersion',
    defaultValue: '',
    component: 'Input',
    label: '应用运行的版本',
    placeholder: '请填写应用运行的版本',
    rules: [
      {
        required: true,
        message: '应用运行的版本不能为空'
      }
    ]
  },
]
